<template>
    <div class="row mx-auto my-5">
        <div class="col-8">
            <!-- Header -->
            <div class="mb-4">
                <h2>{{ $t("transportations.addTransportation") }}</h2>
            </div>
            <!-- Error -->
            <div>
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <!-- Form -->
            <div class="d-flex gap-3">
                <div class="mb-3">
                    <input class="form-check-input me-2" type="radio" name="transportType" id="standardTransport"
                        value="Standardní" v-model="postData.transportType.transportType">
                    <label class="form-check-label" for="standardTransport">
                        {{ $t("transportations.standardTransport") }}
                    </label>
                </div>
                <div class="mb-3">
                    <input class="form-check-input me-2" type="radio" name="transportType" id="bezrukaceTransport"
                        value="bezrukaceTransport" v-model="postData.transportType.transportType">
                    <label class="form-check-label" for="bezrukaceTransport">
                        {{ $t("transportations.bezrukaceTransport") }}
                    </label>
                </div>
                <div v-if="postData.transportType.transportType == 'bezrukaceTransport'">
                    <div class="mb-3">
                        <span>{{ $t('transportations.choices') }}</span>
                        <div class="mt-2">
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="LesProfi">
                                <label class="form-check-label">LesProfi</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="Polácinaši">
                                <label class="form-check-label">Poláci naši</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="LogrealPešek">
                                <label class="form-check-label">Logreal Pešek</label>
                            </div>
                            <div class="mb-2">
                                <input class="form-check-input me-2" type="radio"
                                    v-model="postData.transportType.choice" value="other">
                                <label class="form-check-label">{{ $t('transportations.different') }}</label>
                            </div>
                            <div v-if="postData.transportType.choice == 'other'">
                                <label class="form-check-label">{{ $t('transportations.whoILoaded') }}:</label>
                                <input class="form-control" type="text"
                                    v-model="postData.transportType.differentChoice">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Date -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label" for="date">
                    {{ $t("transportations.date") }} <span class="text-danger">*</span>
                </label>
                <input
                    id="date"
                    type="date"
                    class="form-control"
                    v-model="postData.date"
                >
            </div>

            <!-- Driver -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.driver") }}
                </label>
                <select class="form-select" v-model="postData.driver">
                    <option value="" disabled>{{ $t('transportations.chooseDriver') }}..</option>
                    <option v-for="driver in drivers" :value="driver.id" v-key="driver.id">
                        {{ driver.first_name }} {{ driver.last_name }}
                    </option>
                </select>
            </div>
            <!-- Recipient -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.woodTransportFor") }}
                </label>
                <select class="form-select" v-model="postData.recipient">
                    <option value="" disabled>{{ $t('transportations.chooseRecipient') }}..</option>
                    <option v-for="recipient in data.recipients" :value="recipient.id" v-key="recipient.id">
                        {{ recipient.name }}
                    </option>
                </select>
            </div>
            <div class="form-check-label">{{ $t("transportations.cmrLabel") }}</div>
            <div class="p-3 mb-2 border rounded border-secondary">
                <div v-for="(field, index) in postData.cmrOrWagon" :key="index" class="d-flex align-items-center mb-3">
                    <!-- CMR or Wagon -->
                    <div class="w-50 d-flex flex-column me-3">
                        <label class="form-check-label">
                            {{ $t("transportations.cmrOrWagon") }}
                        </label>
                        <input class="form-control" type="text" v-model="field.cmrOrWagon">
                    </div>
                    <!-- Amount -->
                    <div class="w-50 d-flex flex-column">
                        <label class="form-check-label">
                            {{ $t("transportations.amount") }}
                        </label>
                        <input type="number" min="0" v-model="field.amount" class="form-control">
                    </div>
                    <button v-if="index > 0" type="button" class="btn btn-outline-danger ms-2 mt-4"
                        @click="removeField(index, 'cmr')"><strong>-</strong></button>
                    <button type="button" class="btn btn-outline-primary ms-2 mt-4" @click="addField('cmr')"><strong>+</strong></button>
                </div>
            </div>
            <!-- Subscriber -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.subscriber") }} <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="subscriberSelection">
                    <option value="" disabled>{{ $t('transportations.chooseSubscriber') }}..</option>
                    <option v-for="subscriber in data.subscribers" :value="subscriber.id" v-key="subscriber.id">
                        {{ subscriber.name }}
                    </option>
                    <option value="other">{{ $t('utils.other') }}</option>
                </select>
                <input type="text" v-if="subscriberSelection == 'other'" class="form-control mt-2"
                    v-model="postData.subscriber" placeholder="Zadejte odběratele">
                <input type="hidden" v-else :value="postData.subscriber = subscriberSelection">
            </div>
            <!-- Sortiment -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.sortiment") }}
                </label>
                <select class="form-select" v-model="postData.sortiment">
                    <option value="" disabled>{{ $t('transportations.chooseSortiment') }}..</option>
                    <option v-for="wood_type in data.wood_types" :value="wood_type.id" v-key="wood_type.id">{{
                        wood_type.name }}</option>
                </select>
            </div>
            <div class="form-check-label">{{ $t("transportations.location") }}</div>
            <div class="p-3 mb-2 border rounded border-secondary">
                <div v-for="(field, index) in postData.loadingUnloading" :key="index" class="d-flex mb-3">
                    <!-- Place of loading -->
                    <div class="w-50 d-flex flex-column me-3">
                        <label class="form-check-label">
                            {{ $t("transportations.placeOfLoading") }}
                        </label>
                        <input type="text" class="form-control" v-model="field.loading">
                    </div>
                    <!-- Place of delivery -->
                    <div class="w-50 d-flex flex-column">
                        <label class="form-check-label">
                            {{ $t("transportations.placeOfDelivery") }}
                        </label>
                        <input type="text" class="form-control" v-model="field.unloading">
                    </div>

                    <button v-if="index > 0" type="button" class="btn btn-outline-danger ms-2 mt-4"
                        @click="removeField(index, 'loadingUnloading')">
                        <strong>-</strong>
                    </button>
                    <button type="button" class="btn btn-outline-primary ms-2 mt-4" @click="addField('loadingUnloading')"><strong>+</strong></button>
                </div>
            </div>
            <!-- SPZ -->
            <div class="d-flex flex-column mb-3">
                <label class="form-check-label">
                    {{ $t("transportations.spz") }} <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="spzSelection">
                    <option value="" disabled>{{ $t('transportations.chooseSpz') }}..</option>
                    <option v-for="spz in data.licence_plates" :value="spz.id" v-key="spz.id">{{ spz.name }}</option>
                    <option value="other">{{ $t('utils.other') }}</option>
                </select>
                <input v-if="spzSelection == 'other'" type="text" class="form-control mt-2" v-model="postData.spz"
                    placeholder="Zadejte SPZ">
                <input v-else type="hidden" :value="postData.spz = spzSelection">
            </div>
        </div>
        <!-- Button -->
        <div>
            <button class="btn btn-primary form-submit" @click="submitForm()">{{ $t("utils.submit") }}</button>
        </div>
    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: { VueDatePicker },
    data() {
        return {
            data: [],
            postData: {
                transportType: { transportType: null, choice: null, differentChoice: null },
                date: '',
                driver: '',
                cmrOrWagon: [{ cmrOrWagon: "", amount: null }],
                loadingUnloading: [{ loading: "", unloading: "" }],
                spz: '',
                recipient: '',
                subscriber: '',
                sortiment: '',
            },
            error: null,
            spzSelection: '',
            subscriberSelection: '',
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/drivers").then((response) => {
                this.drivers = response.data.items;
            })
            this.$store.getters.api.get("/transportations/data").then((response) => {
                this.data = response.data.items;
            })
        },
        addField(type) {
            if (type == "cmr") {
                this.postData.cmrOrWagon.push({ cmrOrWagon: "", amount: null });
            }
            else if (type == "loadingUnloading") {
                this.postData.loadingUnloading.push({ loading: "", unloading: "" });
            }
        },
        removeField(index, type) {
            if (type == "cmr") {
                this.postData.cmrOrWagon.splice(index, 1);
            }
            else if (type == "loadingUnloading") {
                this.postData.loadingUnloading.splice(index, 1);
            }
        },
        submitForm() {
            if (
                !this.postData.subscriber ||
                !this.postData.date ||
                !this.postData.spz
            ) {
                this.error = this.$t("error.missingFields");
            }
            else {
                this.$store.getters.api.post("/transportation/add", this.postData)
                    .then((response) => {
                        this.$router.push({ name: "Transportations" });
                    })
            }
        }
    }
}

</script>
<style lang="">

</style>
